<script lang="ts">
export default {
  name: 'Spinner',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    size?: 'xs' | 'sm' | 'md' | 'lg';
    type?: 'spinner' | 'dots' | 'ring';
    class?: string;
  }>(),
  {
    size: 'md',
    type: 'spinner',
  }
);

const spinnerClasses = computed(() => {
  const classes = ['loading'];
  
  switch (props.type) {
    case 'dots':
      classes.push('loading-dots');
      break;
    case 'ring':
      classes.push('loading-ring');
      break;
    case 'spinner':
    default:
      classes.push('loading-spinner');
      break;
  }
  
  switch (props.size) {
    case 'xs':
      classes.push('loading-xs');
      break;
    case 'sm':
      classes.push('loading-sm');
      break;
    case 'lg':
      classes.push('loading-lg');
      break;
    case 'md':
    default:
      // md is default, no class needed
      break;
  }
  
  if (props.class) {
    classes.push(props.class);
  }
  
  return classes.join(' ');
});
</script>

<template>
  <span :class="spinnerClasses"></span>
</template>
